export const TypesCarregamentoPosDescarga = {
    SET_SEARCH_TEXT: 'carregamentoPosDescarga/SET_SEARCH_TEXT',
    SET_SELECTED_CONTAINER: 'carregamentoPosDescarga/SET_SELECTED_CONTAINER',
    SET_CONTAINER_LIST: 'carregamentoPosDescarga/SET_CONTAINER_LIST',
    SET_ADDED_CONTAINERS: 'carregamentoPosDescarga/SET_ADDED_CONTAINERS',
    SET_REMOVE_CONTAINERS_LIST: 'carregamentoPosDescarga/SET_REMOVE_CONTAINERS_LIST',
    RESET_CARREGAMENTO_POS_DESCARGA: 'carregamentoPosDescarga/RESET_CARREGAMENTO_POS_DESCARGA'
}

const INITIAL = {
    SearchText: '',
    SelectedContainer: null,
    ContainerList: [],
    AddedContainers: [],
    RemoveContainersList: []
}

export default function carregamentoPosDescargaReducer(state = INITIAL, action) {
    switch (action.type) {
        case TypesCarregamentoPosDescarga.SET_SEARCH_TEXT:
            return {
                ...state,
                SearchText: action.payload.searchText
            }
        case TypesCarregamentoPosDescarga.SET_SELECTED_CONTAINER:
            return {
                ...state,
                SelectedContainer: action.payload.selectedContainer
            }
        case TypesCarregamentoPosDescarga.SET_CONTAINER_LIST:
            return {
                ...state,
                ContainerList: action.payload.containerList
            }
        case TypesCarregamentoPosDescarga.SET_ADDED_CONTAINERS:
            return {
                ...state,
                AddedContainers: action.payload.addedContainers
            }
        case TypesCarregamentoPosDescarga.SET_REMOVE_CONTAINERS_LIST:
            return {
                ...state,
                RemoveContainersList: action.payload.removeContainersList
            }
        case TypesCarregamentoPosDescarga.RESET_CARREGAMENTO_POS_DESCARGA:
            return INITIAL;
        default:
            return state;
    }
}

export const CarregamentoPosDescargaActions = {
    setSearchText,
    setSelectedContainer,
    setContainerList,
    setAddedContainers,
    setRemoveContainersList,
    resetCarregamentoPosDescarga
}

function setSearchText(searchText) {
    return {
        type: TypesCarregamentoPosDescarga.SET_SEARCH_TEXT,
        payload: { searchText: searchText }
    }
}

function setSelectedContainer(selectedContainer) {
    return {
        type: TypesCarregamentoPosDescarga.SET_SELECTED_CONTAINER,
        payload: { selectedContainer: selectedContainer }
    }
}

function setContainerList(containerList) {
    return {
        type: TypesCarregamentoPosDescarga.SET_CONTAINER_LIST,
        payload: { containerList: containerList }
    }
}

function setAddedContainers(addedContainers) {
    return {
        type: TypesCarregamentoPosDescarga.SET_ADDED_CONTAINERS,
        payload: { addedContainers: addedContainers }
    }
}

function setRemoveContainersList(removeContainersList) {
    return {
        type: TypesCarregamentoPosDescarga.SET_REMOVE_CONTAINERS_LIST,
        payload: { removeContainersList: removeContainersList }
    }
}

function resetCarregamentoPosDescarga() {
    return {
        type: TypesCarregamentoPosDescarga.RESET_CARREGAMENTO_POS_DESCARGA
    }
}